<template>
  <div>
    <b-modal
      id="modal-confirm"
      size="md"
      title="Create Building"
      ok-title="Save"
      cancel-title="Cancel"
      no-close-on-backdrop
      centered
      hide-header
    >
      <div class="d-flex justify-content-center mb-3">
        <div v-if="isTrashIcon" class="d-flex justify-content-center">
          <div
            style="
              background: rgba(207, 75, 59, 0.1);
              border-radius: 100%;
              padding: 20px;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 109 109"
              fill="none"
            >
              <g clip-path="url(#clip0_761_35444)">
                <path
                  d="M92.0488 13.3457H76.2285V10.1816C76.2285 4.94765 71.9703 0.689453 66.7363 0.689453H41.4238C36.1898 0.689453 31.9316 4.94765 31.9316 10.1816V13.3457H16.1113C10.8773 13.3457 6.61914 17.6039 6.61914 22.8379C6.61914 27.0415 9.3666 30.6133 13.1593 31.8578L18.8029 99.9853C19.2094 104.866 23.3644 108.689 28.2622 108.689H79.898C84.796 108.689 88.951 104.866 89.3577 99.9839L95.0009 31.8576C98.7936 30.6133 101.541 27.0415 101.541 22.8379C101.541 17.6039 97.2828 13.3457 92.0488 13.3457ZM38.2598 10.1816C38.2598 8.43698 39.6792 7.01758 41.4238 7.01758H66.7363C68.481 7.01758 69.9004 8.43698 69.9004 10.1816V13.3457H38.2598V10.1816ZM83.0511 99.4601C82.9154 101.087 81.5306 102.361 79.898 102.361H28.2622C26.6297 102.361 25.2447 101.087 25.1095 99.4616L19.5483 32.3301H88.6118L83.0511 99.4601ZM92.0488 26.002H16.1113C14.3667 26.002 12.9473 24.5826 12.9473 22.8379C12.9473 21.0932 14.3667 19.6738 16.1113 19.6738H92.0488C93.7935 19.6738 95.2129 21.0932 95.2129 22.8379C95.2129 24.5826 93.7935 26.002 92.0488 26.002Z"
                  fill="#CF4B3B"
                />
                <path
                  d="M41.4177 92.6735L38.2537 41.6266C38.1454 39.8824 36.6358 38.5558 34.9 38.6644C33.1557 38.7726 31.8296 40.2741 31.9376 42.0181L35.1016 93.0652C35.2056 94.7428 36.5986 96.0335 38.2566 96.0335C40.089 96.0335 41.5301 94.4903 41.4177 92.6735Z"
                  fill="#CF4B3B"
                />
                <path
                  d="M54.0801 38.6582C52.3327 38.6582 50.916 40.0749 50.916 41.8223V92.8691C50.916 94.6165 52.3327 96.0332 54.0801 96.0332C55.8275 96.0332 57.2441 94.6165 57.2441 92.8691V41.8223C57.2441 40.0749 55.8275 38.6582 54.0801 38.6582Z"
                  fill="#CF4B3B"
                />
                <path
                  d="M73.26 38.6644C71.5197 38.5562 70.0143 39.8823 69.9063 41.6266L66.7422 92.6735C66.6344 94.4175 67.9606 95.9189 69.7046 96.0271C71.4497 96.1352 72.9503 94.8084 73.0583 93.065L76.2224 42.0181C76.3304 40.2738 75.0042 38.7724 73.26 38.6644Z"
                  fill="#CF4B3B"
                />
              </g>
              <defs>
                <clipPath id="clip0_761_35444">
                  <rect
                    width="108"
                    height="108"
                    fill="white"
                    transform="translate(0.0800781 0.689453)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <b-icon
          v-else
          icon="exclamation-circle"
          style="width: 75px; height: 75px"
          class="text-warning"
        ></b-icon>
      </div>
      <div class="text-center">
        <h3>{{ textHeader }}</h3>
        <span class="text-danger">{{ subText }}</span>
      </div>
      <template #modal-footer="{}">
        <button
          v-if="isTrashIcon"
          class="btn me-auto"
          style="color: #f00; border: 1px solid #f00"
          @click="closeModal()"
        >
          Cancel
        </button>
        <button
          v-if="isTrashIcon"
          class="btn button-red"
          @click="deleteFile()"
        >
          Delete
        </button>
        <button
          v-if="!isTrashIcon"
          class="btn button-outline-green me-auto"
          @click="closeModal()"
        >
          ยกเลิก
        </button>
        <button
          v-if="!isTrashIcon"
          class="btn button-green px-5"
          @click="confirmCreate()"
        >
          บันทึก
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    textHeader: {
      type: String,
      default: "",
    },
    subText: {
      type: String,
      default: "",
    },
    isTrashIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-confirm");
    },
    confirmCreate() {
      this.$emit("confirmCreate");
    },
    deleteFile() {
      this.$emit("deleteFile");
    },
  },
};
</script>

<style lang="scss">
#modal-confirm {
  border-bottom: none !important;
}
</style>
